export default __webpack_public_path__ + "static/media/Devices.346eab39.PNG";